import type { ApolloClient } from '@apollo/client';
import { client } from '../../client';
import { mapResult } from '../result';
import {
  RunAmsReconciliationDocument,
  RunAmsReconciliationMutation,
  RunAmsReconciliationMutationVariables
} from '../../graphql';

export const runAmsReconciliation = async (
  input: RunAmsReconciliationMutationVariables['input'],
  apollo: ApolloClient<object> = client
) =>
  mapResult(
    await apollo.mutate<RunAmsReconciliationMutation, RunAmsReconciliationMutationVariables>({
      mutation: RunAmsReconciliationDocument,
      variables: { input }
    }),
    (data) => data?.runAmsReconciliation
  );
